// extracted by mini-css-extract-plugin
export var printerCard = "_j6-1";
export var printerCardConfigured = "_j6-2";
export var printerCardError = "_j6-3";
export var printerCardsContainer = "_j6-0";
export var printerIcon = "_j6-8";
export var printerIconConfigured = "_j6-5";
export var printerIconContainer = "_j6-4";
export var printerIconError = "_j6-6";
export var printerIconUnconfigured = "_j6-7";
export var workstationsTableCard = "_j6-9";